<script>import * as d3 from "d3";
import { tweened } from "svelte/motion";
import { cubicOut } from "svelte/easing";
export let duration = 400;
export let easing = cubicOut;
export let arcDatum;
export let sliceArc;
export let title;
const tweenPieArcDatum = tweened(arcDatum, {
  duration,
  easing,
  interpolate: (from, to) => {
    const interpolate = d3.interpolate(from, to);
    return (t) => interpolate(t);
  }
});
$: {
  tweenPieArcDatum.set(arcDatum);
}
</script>

<path
	class="arc"
	fill={arcDatum.data.color.formatHex()}
	fill-opacity={arcDatum.data.color.opacity}
	d={sliceArc($tweenPieArcDatum)}>{#if title}<title>{title(arcDatum.data)}</title>{/if}</path
>
